import { WarningDiamondIcon } from "@xola/icons";
import { Badge, Tooltip } from "@xola/ui-kit";
import React from "react";

export const PurchaseDisputeBadge = () => {
    return (
        <Tooltip content={disputeBadgeInfo.title}>
            <div className="inline-flex items-center tracking-tightest" data-testid="purchase-status-icon">
                <Badge
                    color={disputeBadgeInfo.color}
                    icon={<WarningDiamondIcon size="small" className="text-danger" />}
                >
                    {disputeBadgeInfo.title}
                </Badge>
            </div>
        </Tooltip>
    );
};

export const disputeBadgeInfo = {
    color: "danger",
    icon: <WarningDiamondIcon size="medium" className="text-danger" />,
    title: "Dispute",
};
